export interface BlockData {
  title: string;
  icon: string;
}

// TODO: Set up with Sanity and get coaches to add the activites
const blocksData: { [key: string]: BlockData } = {
  walk10t: { title: "Walk 10,000 steps", icon: "🚶‍♀️" },
  read10: { title: "Read 10 pages", icon: "🧗" },
  read20: { title: "Read 20 pages", icon: "🚀" },
  audiobook30: { title: "Listen to 30mins of Audiobook", icon: "🧑‍💼" },
};

export default blocksData;
